import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SwiftIdApplicationStatus } from './swift-id-application-status.model';

/**
 * Options for generating a SwiftID application status
 */
export interface GenerateSwiftIdApplicationStatusOptions {
  readonly id?: number;
  readonly uuid?: string;
  readonly userId?: number;
  readonly username?: string;
  readonly accountType?: string;
  readonly primaryGivenName?: string;
  readonly primarySurname?: string;
  readonly status?: string;
  readonly invitationStatus?: string;
  readonly invitationId?: number;
  readonly substatus?: string;
  readonly backOfficeAccountNumber?: string;
  readonly createdAt?: number;
  readonly updatedAt?: number;
}

/**
 * Generates a SwiftID application status object
 */
export function generateSwiftIdApplicationStatusObject({
  id = generateId(),
  uuid = undefined,
  userId = generateId(),
  username = 'testusername',
  accountType = 'Individual',
  primaryGivenName = 'Test',
  primarySurname = 'Name',
  status = 'Submitted',
  invitationStatus = undefined,
  invitationId = undefined,
  substatus = undefined,
  backOfficeAccountNumber = undefined,
  createdAt = Date.now(),
  updatedAt = Date.now(),
}: GenerateSwiftIdApplicationStatusOptions): SwiftIdApplicationStatus {
  return {
    id,
    uuid,
    userId,
    username,
    accountType,
    primaryGivenName,
    primarySurname,
    status,
    invitationStatus,
    invitationId,
    substatus,
    backOfficeAccountNumber,
    createdAt,
    updatedAt,
  };
}
